<template>
  <div class="ai-platform-page">
    <div class="ai-hero-banner">
      <img
        src="@/assets/jiejue/custom/password-top-clean2.png"
        alt=""
        style="width: 100%"
        class="top_img"
        @load="loaded = true"
        :class="{ show: loaded }"
      />
      <div class="ai-hero-title">密码云安全资源池解决方案</div>
    </div>

    <nav class="product-tabs-bar">
      <a class="product-tab" :class="{ active: activeTab === 'background' }" href="#background" @click.prevent="scrollTo('background')">需求背景</a>
      <a class="product-tab" :class="{ active: activeTab === 'challenges' }" href="#challenges" @click.prevent="scrollTo('challenges')">业务挑战</a>
      <a class="product-tab" :class="{ active: activeTab === 'scenarios' }" href="#scenarios" @click.prevent="scrollTo('scenarios')">场景应用</a>
      <a v-if="SHOW_SOLUTION_DEPLOY_DIAGRAM" class="product-tab" :class="{ active: activeTab === 'architecture' }" href="#architecture" @click.prevent="scrollTo('architecture')">部署示意图</a>
      <a class="product-tab" :class="{ active: activeTab === 'advantages' }" href="#advantages" @click.prevent="scrollTo('advantages')">方案优势</a>
      <a class="product-tab" :class="{ active: activeTab === 'cases' }" href="#cases" @click.prevent="scrollTo('cases')">典型案例</a>
    </nav>

    <div class="product-body">
    <section id="background" class="product-section section-row ai-platform-block" :class="{ 'animate-in': backgroundVisible }">
      <div class="section-title">需求背景</div>
      <div class="section-content">
        <div class="background-card">
          <p class="case-text case-text-full">
            基于密码资源池满足密评场景下密码合规问题，降低建设成本，满足密码合规要求。
          </p>
        </div>
      </div>
    </section>

    <section id="challenges" class="product-section section-row ai-platform-block" :class="{ 'animate-in': challengesVisible }">
      <div class="section-title">业务挑战</div>
      <div class="section-content">
        <div class="grid-2">
          <div class="card">
            <img class="card-icon" src="@/assets/jiejue/sase/1.svg" alt="icon" />
            <div class="card-text">
              <div class="card-title">密码资源分散低效</div>
              <div class="card-desc">
                传统密码部署采用“一机一密”模式，密码设备（密码机、签名验签服务器等）分散部署于各业务系统，缺乏统一调度与管理，导致密码资源利用率偏低，部分设备长期闲置，而核心业务又面临密码算力不足的问题，资源分配失衡。
              </div>
            </div>
          </div>
          <div class="card">
            <img class="card-icon" src="@/assets/jiejue/sase/2.svg" alt="icon" />
            <div class="card-text">
              <div class="card-title">多场景适配能力不足</div>
              <div class="card-desc">
                不同业务系统（如政务服务、数据共享、电子交易）的密码需求差异显著，有的需要高强度数据加密，有的侧重身份认证与签名验签，传统密码部署模式无法快速适配差异化需求，且新增业务系统时，需重新部署密码设备，部署周期长、成本高。
              </div>
            </div>
          </div>
          <div class="card">
            <img class="card-icon" src="@/assets/jiejue/sase/3.svg" alt="icon" />
            <div class="card-text">
              <div class="card-title">密钥管理不规范</div>
              <div class="card-desc">
                缺乏统一的密钥全生命周期管理机制，密钥的生成、存储、使用、销毁、备份等环节缺乏有效管控，易出现密钥泄露、丢失、滥用等风险，同时无法实现密钥的集中审计与追溯，难以满足合规要求。
              </div>
            </div>
          </div>
          <div class="card">
            <img class="card-icon" src="@/assets/jiejue/sase/4.svg" alt="icon" />
            <div class="card-text">
              <div class="card-title">合规压力持续增大</div>
              <div class="card-desc">
                《密码法》《网络安全法》《信息安全技术 密码应用基本要求》等法规明确要求，核心业务系统需采用国密算法，完成商用密码应用安全性评估，传统分散式密码部署无法实现合规集中管控，导致合规整改难度大、周期长。
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>

    <section id="scenarios" class="product-section section-row ai-platform-block" :class="{ 'animate-in': scenariosVisible }">
      <div class="section-title">场景应用</div>
      <div class="section-content">
      <div class="scenarios">
        <div class="scenario-text">
          <div class="scenario-item">
            <div class="item-title">政务领域场景</div>
            <div class="item-desc">
              适配省级、地市级政务云平台，覆盖政务服务、市域治理、数据共享交换等核心业务，承载各区县、各部门的业务系统密码需求，需实现多租户隔离、密码资源统一调度，同时满足等保2.0、商用密码应用安全性评估及政务数据安全要求，保障政务敏感数据全流程加密防护。
            </div>
          </div>
          <div class="scenario-item highlight">
            <div class="item-title">企业级场景</div>
            <div class="item-desc">
              适配大型集团企业的混合云、私有云架构，覆盖企业ERP、CRM、供应链管理等业务系统，以及远程办公、跨区域数据传输等场景，需实现密码资源的弹性扩展，适配不同业务模块的差异化密码需求，简化密码运维管理，降低密码部署与运营成本。
            </div>
          </div>
        </div>
        <!-- <div class="scenario-image" aria-label="方案示意图"></div> -->
         <img src="@/assets/jiejue/passwordCompression/right.png" alt="" style="width: 50%; border-radius: 4px;" class="mobile-hidden-img">
      </div>
      </div>
    </section>

    <section v-if="SHOW_SOLUTION_DEPLOY_DIAGRAM" id="architecture" class="product-section section-row ai-platform-block" :class="{ 'animate-in': architectureVisible }">
      <div class="section-title">部署示意图</div>
      <div class="section-content">
      <img src="@/assets/solutions/deploy/password.svg" alt="部署示意图" class="architecture-image">
      </div>
    </section>

    <section id="advantages" class="product-section section-row advantages ai-platform-block" :class="{ 'animate-in': advantagesVisible }">
      <div class="section-title">方案优势</div>
      <div class="section-content">
        <div class="grid-4">
          <div class="adv-card">
            <img src="@/assets/jiejue/1.svg" alt="" class="adv-badge" />
            <div class="adv-title">资源集约化，降低成本提升效率</div>
            <div class="adv-desc">
              通过密码资源池化整合，打破“一机一密”的分散格局，实现密码资源的统一调度与弹性分配，将密码资源利用率提升至80%以上，避免资源闲置；同时减少单独部署密码设备的硬件投入、机房占用与运维成本，新增业务系统时可快速调用现有密码资源，缩短部署周期。
            </div>
          </div>
          <div class="adv-card">
            <img src="@/assets/jiejue/2.svg" alt="" class="adv-badge" />
            <div class="adv-title">多场景适配，灵活满足差异化需求</div>
            <div class="adv-desc">
              采用标准化接口与多协议兼容设计，可快速适配政务、金融、企业等不同领域的业务系统，提供数据加解密、签名验签、身份认证等多样化密码服务；支持根据业务需求动态调整密码算力与资源分配，适配高并发、高强度密码需求场景，兼顾通用性与针对性。
            </div>
          </div>
          <div class="adv-card">
            <img src="@/assets/jiejue/3.svg" alt="" class="adv-badge" />
            <div class="adv-title">安全合规，保障密码与数据安全</div>
            <div class="adv-desc">
              全面适配SM2、SM3、SM4等国密算法，严格遵循《密码法》等相关法规要求，可快速通过商用密码应用安全性评估与等保测评；建立完善的密钥全生命周期管理与安全审计机制，实现密钥安全存储、规范使用与全程追溯，同时通过多租户隔离、访问控制等技术，防止密码资源滥用与数据泄露，构建全方位密码安全防护体系。
            </div>
          </div>
          <div class="adv-card">
            <img src="@/assets/jiejue/4.svg" alt="" class="adv-badge" />
            <div class="adv-title">运维便捷，提升管理效率</div>
            <div class="adv-desc">
              通过统一管控平台，实现密码资源、密钥、安全事件的集中管理，支持实时监控、故障告警、远程运维，大幅减少运维人员工作量；可视化管理界面可直观展示密码资源使用状态、密钥生命周期、安全事件等信息，助力管理人员快速决策，提升密码安全管理的智能化、便捷化水平。
            </div>
          </div>
        </div>
      </div>
    </section>

    <section id="cases" class="product-section section-row ai-platform-block" :class="{ 'animate-in': casesVisible }">
      <div class="section-title">典型案例</div>
      <div class="section-content section-content-cases">
        <div class="case-content case-content-blink">
          <div class="case-section">
            <h3 class="case-subtitle">需求背景</h3>
            <p class="case-text">
              某地级市推进市域治理现代化建设，搭建市域治理现代化指挥中心，覆盖全市各区县、各部门，需实现数十亿量级的数据全量汇聚共享，涉及市域治理、电子政务等多个核心业务，业务范围广、种类多，对密码管理服务提出了更高要求。当前，该市面临的密码管理痛点是：传统“一机一密”的密码部署模式，密码设备分散，无法实现统一调度和分配，资源利用率低；不同业务系统的密码需求差异大，需提供差异化的密码服务，同时保障租户间的安全隔离；密码服务缺乏统一的管理平台，密钥全生命周期管理不规范，易出现密钥泄露、丢失等风险；需满足《密码法》和等保2.0要求，通过商用密码应用安全性评估。为解决上述问题，该市引入密码云安全资源池解决方案，构建市域治理统一密码服务平台。
            </p>
          </div>
          <div class="case-section">
            <h3 class="case-subtitle">用户痛点</h3>
            <ul class="case-list">
              <li>1. 密码资源调度难：密码设备分散部署，接口不统一，无法实现集中调度和弹性分配，难以适配不同业务系统的差异化需求，资源利用率低；</li>
              <li>2. 租户隔离与安全保障难：市域治理平台涵盖多个区县、部门，需实现不同租户间的物理隔离，确保各自密码资源的独立可控，防止密码服务滥用；</li>
              <li>3. 密钥管理不规范：缺乏统一的密钥全生命周期管理机制，密钥的生成、存储、使用、销毁等环节缺乏有效管控，存在安全风险；</li>
              <li>4. 合规适配难度大：需严格遵循《密码法》、《信息安全技术密码应用基本要求》等法规，实现国密算法适配，顺利通过商用密码应用安全性评估。</li>
            </ul>
          </div>
          <div class="case-section">
            <h3 class="case-subtitle">解决方案</h3>
            <ul class="case-list">
              <li>1. 构建统一密码资源池：采用虚拟化技术，将多个独立的密码设备（含云密码机、服务器密码机、签名验签服务器等）整合为密码云安全资源池，实现密码资源的统一调度和弹性分配；引入分层调度算法，根据各业务系统的密码需求，动态调整虚拟密码机大小，解决资源不足或闲置的问题，提升资源利用率。</li>
              <li>2. 实现租户隔离与差异化服务：支持多租户管理，租户间实现物理隔离，各自只能访问自己的密码设备资源；将底层密码能力封装为标准化API，提供数据加解密、签名验签、身份认证等通用密码服务，租户可按需订阅，满足不同业务系统的差异化需求。</li>
              <li>3. 规范密钥全生命周期管理：搭建统一的密码管理平台，实现密钥生成、存储、使用、销毁、备份等全生命周期的集中管控；采用严格的权限管理机制，阻止非法访问，内置完善的日志审计功能，实时监测密码服务调用记录，确保密钥安全可控。</li>
              <li>4. 满足合规要求：全面适配SM2/SM3/SM4国密算法，将合规要求嵌入方案设计全流程，实现密码服务的标准化、规范化；搭建密码可视化平台，直观展示密码使用情况，辅助管理人员决策；通过商用密码应用安全性评估，满足《密码法》和等保2.0要求，为市域治理数据提供全生命周期的安全防护。</li>
            </ul>
          </div>
        </div>
      </div>
    </section>
    </div>

    
  </div>
</template>

<script setup>
import { ref, onMounted, onBeforeUnmount, nextTick } from 'vue'
import { SHOW_SOLUTION_DEPLOY_DIAGRAM } from '@/data/solutionUi.js'
const loaded = ref(false)
const backgroundVisible = ref(false)
const challengesVisible = ref(false)
const scenariosVisible = ref(false)
const architectureVisible = ref(false)
const advantagesVisible = ref(false)
const casesVisible = ref(false)

const activeTab = ref('background')
const scrollTo = (id) => {
  const el = document.getElementById(id)
  if (!el) return
  
  // 立即设置activeTab，确保点击时立即高亮
  activeTab.value = id
  history.replaceState(null, '', `#${id}`)
  
  // 设置标志，表示这是程序触发的滚动
  isScrollingProgrammatically.value = true
  
  // 滚动到目标元素
  if (el.scrollIntoView) {
    el.scrollIntoView({ behavior: 'smooth', block: 'start' })
  } else {
    const stickyOffset = 120
    const y = el.getBoundingClientRect().top + window.scrollY - stickyOffset
    window.scrollTo({ top: y, behavior: 'smooth' })
  }
  
  // 滚动完成后重置标志，允许IntersectionObserver再次更新activeTab
  setTimeout(() => {
    isScrollingProgrammatically.value = false
  }, 1000) // 延迟约1秒
}

// 动画与导航观察器
const animationObserver = ref(null)
const navObserver = ref(null)
const navTimeout = ref(null)
const isScrollingProgrammatically = ref(false) // 防止程序滚动时覆盖activeTab

// 检查元素是否在视口内
const checkElementVisibility = (element) => {
  const rect = element.getBoundingClientRect()
  const viewportHeight = window.innerHeight || document.documentElement.clientHeight
  // 元素与视口有交叉即视为可见
  return rect.top < viewportHeight && rect.bottom > 0
}

// 观察所有区块
const observeBlocks = () => {
  const ids = ['background', 'challenges', 'scenarios', 'architecture', 'advantages', 'cases']
  
  // 动画观察器 - 控制 animate-in
  const animationObserver = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          const id = entry.target.id
          if (id === 'background') backgroundVisible.value = true
          if (id === 'challenges') challengesVisible.value = true
          if (id === 'scenarios') scenariosVisible.value = true
          if (id === 'architecture') architectureVisible.value = true
          if (id === 'advantages') advantagesVisible.value = true
          if (id === 'cases') casesVisible.value = true
        }
      })
    },
    { root: null, threshold: 0.1, rootMargin: '-10% 0px -10% 0px' }
  )
  
  // 导航观察器 - 根据滚动更新 activeTab
  const navigationObserver = new IntersectionObserver(
    (entries) => {
      // 若是程序触发的滚动，不在此处更新 activeTab
      if (isScrollingProgrammatically.value) return
      
      const visible = entries.filter((e) => e.isIntersecting)
      if (!visible.length) return
      visible.sort((a, b) => b.intersectionRatio - a.intersectionRatio)
      const id = visible[0].target.id
      if (id && activeTab.value !== id) {
        activeTab.value = id
        history.replaceState(null, '', `#${id}`)
      }
    },
    {
      root: null,
      threshold: [0.25, 0.5, 0.75],
      rootMargin: '-80px 0px -50% 0px',
    }
  )
  
  // 为每个区块添加观察
  ids.forEach((id) => {
    const el = document.getElementById(id)
    if (el && el.classList.contains('ai-platform-block')) {
      // 若已在视口内则先显示
      if (checkElementVisibility(el)) {
        if (id === 'challenges') challengesVisible.value = true
        if (id === 'scenarios') scenariosVisible.value = true
        if (id === 'architecture') architectureVisible.value = true
        if (id === 'advantages') advantagesVisible.value = true
      }
      // 开始观察
      animationObserver.observe(el)
      navigationObserver.observe(el)
    }
  })
  
  animationObserver.value = animationObserver
  navObserver.value = navigationObserver
}

onMounted(async () => {
  // 刷新页面时清除 URL 中的 hash，并重置 activeTab
  if (location.hash) {
    history.replaceState(null, '', location.pathname)
    activeTab.value = 'background'
  }
  
  // 等待 DOM 完全渲染后再设置观察器
  await nextTick()
  observeBlocks()
})

onBeforeUnmount(() => { 
  if (animationObserver.value) animationObserver.value.disconnect()
  if (navObserver.value) navObserver.value.disconnect()
  if (navTimeout.value) clearTimeout(navTimeout.value)
})
</script>

<style scoped>
@import '../../assets/css/solution-page.css';

.ai-hero-banner {
  position: relative;
  overflow: hidden;
}

.ai-hero-title {
  position: absolute;
  top: 50%;
  left: 12%;
  transform: translateY(-50%);
  font-size: 48px;
  color: var(--color-text);
  font-weight: 600;
  letter-spacing: 0.01em;
  text-shadow: 0 8px 24px rgba(255, 255, 255, 0.6);
  z-index: 2;
  pointer-events: none;
  white-space: nowrap;
}

.ai-platform-page {
  font-family: 'PingFang SC', 'Microsoft YaHei', sans-serif;
  color: var(--color-text);
}

.ai-platform-block { opacity: 0; transform: translateY(30px); transition: opacity 0.6s ease, transform 0.6s ease; }
.ai-platform-block.animate-in { opacity: 1; transform: translateY(0); }
.background-card { width: 100%; box-sizing: border-box; background: #fff; border-radius: 8px; padding: 36px 40px; box-shadow: 0 2px 12px rgba(0,0,0,0.08); border: 1px solid #e8e8e8; }
.background-card:hover { box-shadow: 0 8px 24px rgba(0,0,0,0.12); }
.case-content { max-width: 100%; margin: 0 auto; text-align: left; }
.section-content-cases { text-align: left; }
.case-content-blink { padding: 24px; border-radius: 8px; animation: case-blink 2.5s ease-in-out infinite; }
@keyframes case-blink { 0%,100%{opacity:1;box-shadow:0 0 0 rgba(6,85,159,0)} 50%{opacity:.88;box-shadow:0 0 28px rgba(6,85,159,0.25)} }
.case-section + .case-section { margin-top: 32px; }
.case-subtitle { font-size: 20px; font-weight: 600; color: #06559f; margin-bottom: 12px; }
.case-text { font-size: 14px; line-height: 1.8; color: #333; }
.case-text-full { font-size: 16px; line-height: 1.9; text-align: left; }
.case-list { font-size: 14px; line-height: 1.8; color: #333; padding-left: 0; list-style: none; }
@media (max-width: 1200px) { .mobile-hidden-img { display: none } }

.hero {
  position: relative;
  height: 360px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: linear-gradient(110deg, #eaf2ff 0%, #f7fbff 40%, #eef5ff 60%, #dfeaff 100%);
  overflow: hidden;
}

.hero::after {
  content: '';
  position: absolute;
  inset: 0;
  background: radial-gradient(1200px 360px at 75% 20%, rgba(24,144,255,0.18) 0%, rgba(24,144,255,0) 60%),
              radial-gradient(800px 300px at 20% 80%, rgba(64,158,255,0.20) 0%, rgba(64,158,255,0) 60%);
}

.hero-inner {
  position: relative;
  z-index: 1;
  max-width: 1100px;
  padding: 0 24px;
  text-align: left;
}

.hero-inner h1 {
  font-size: 40px;
  line-height: 40px;
  margin-bottom: 18px;
  color: #0f172a;
}

.hero-inner p {
  font-size: 16px;
  line-height: 1.7;
  color: #333;
}

.block { 
      scroll-margin-top: 120px;
    max-width: 1420px;
    margin: 0 auto;
    padding: 60px 20px 90px 20px;
 }

.grid-2 { display: grid; grid-template-columns: repeat(2, 1fr); gap: 20px; }
.grid-4 { display: grid; grid-template-columns: repeat(3, 1fr); gap: 20px; }

.card {
  display: flex;
  align-items: flex-start;
  gap: 17px;
  background:  #F5F7FA;;
  /* border: 1px solid #E6EBF5; */
  /* box-shadow: 0px 3px 6px 0px #EBEFF7; */
  border-radius: 6px;
  padding: 30px 30px;
  min-height: 173px;
  box-sizing: border-box;
}

.card-icon { flex-shrink: 0; }
.card-text { display: flex; flex-direction: column;text-align: start; }
.card-title { 
  font-family: PingFang SC;
font-size: 18px;
font-weight: 600;
line-height: normal;
letter-spacing: 0em;

font-variation-settings: "opsz" auto;
color: #000000;
line-height: 40px;
 }
.card-desc { font-size: 14px; line-height: 1.7; color: #666; }

.scenarios {
  display: flex;
  /* grid-template-columns: minmax(0, 1fr) 629px; */
  /* gap: 0; */
  align-items: stretch;
  position: relative;
  max-width: 1200px;
  margin: 0 auto;
}

.scenario-text {
  background: #fff;
  border-radius: 4px;
  /* box-shadow: 0px 3px 6px 0px #EBEFF7; */
  padding: 50px 50px 0px 40px;
  /* height: 369px; */
  box-sizing: border-box;
  border-top-right-radius: 0;
  border-bottom-right-radius: 0;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  overflow: hidden;
  text-align: start;
}

.scenario-item { margin-bottom: 18px; }
.scenario-item .item-title { font-size: 16px; line-height: 16px; color: #333; margin-bottom: 8px;font-family: PingFang SC; }
.scenario-item .item-desc { font-size: 14px; line-height: 1.8; color: #666; }
/* .scenario-item.highlight .item-title { color: #FF6A00; } */

.scenario-image {
  background-image: url('@/assets/jiejue/ai-tiaozhan/1.jpg');
  background-size: cover;
  background-position: center;
  border-radius: 6px;
  border-top-left-radius: 0;
  border-bottom-left-radius: 0;
  width: 629px;
  height: 369px;
  box-sizing: border-box;
  position: relative;
  overflow: hidden;
}

.scenario-image::before {
  content: '';
  position: absolute;
  left: 0;
  top: 0;
  height: 100%;
  width: 40%;
  background: linear-gradient(90deg, rgba(255,255,255,1) 0%, rgba(255,255,255,0.85) 40%, rgba(255,255,255,0) 100%);
  pointer-events: none;
}

.diagram { display: grid; gap: 12px; }
.layer { background: #fff; border: 1px solid #e6ebf5; border-radius: 6px; }
.layer-title { padding: 10px 14px; font-size: 14px; color: #333; background: #f6f9ff; border-color: #dfe8ff; }
.layer-title.blue { background: #e8f2ff; border-color: #cfe0ff; }
.grid.layer-app { display: grid; grid-template-columns: repeat(4, 1fr); gap: 8px; padding: 12px; }
.grid.layer-ml { display: grid; grid-template-columns: repeat(5, 1fr); gap: 8px; padding: 12px; }
.grid.layer-data { display: grid; grid-template-columns: repeat(5, 1fr); gap: 8px; padding: 12px; }
.grid.layer-infra { display: grid; grid-template-columns: repeat(5, 1fr); gap: 8px; padding: 12px; }
.grid.layer-app > div,
.grid.layer-ml > div,
.grid.layer-data > div,
.grid.layer-infra > div { background: #f9fbff; border: 1px dashed #e1e9ff; border-radius: 6px; padding: 12px; text-align: center; font-size: 13px; }

@media (max-width: 1200px) {
  .grid-2 { grid-template-columns: 1fr; }
  .grid-4 { grid-template-columns: repeat(2, 1fr); }
  .scenarios { grid-template-columns: 1fr; }
}

@media (max-width: 768px) {
  .hero { height: 280px; }
  .hero-inner h1 { font-size: 28px; line-height: 28px; }
  .block { padding: 56px 5%; }
  .grid-2 { grid-template-columns: 1fr; }
  .grid-4 { grid-template-columns: 1fr; }
  .section-nav { top: 56px; gap: 16px; height: 48px; }
  .section-nav a { font-size: 13px; }
  .grid.layer-ml,
  .grid.layer-data,
  .grid.layer-infra { grid-template-columns: repeat(2, 1fr); }
  .scenario-image { width: 100%; height: 280px; }
  .scenario-text { height: auto; border-radius: 6px; }
}

.fade-enter-active, .fade-leave-active { transition: opacity .25s ease; }
.fade-enter-from, .fade-leave-to { opacity: 0; }
#advantages { background: linear-gradient(180deg, #F5F7FA 0%, #E0ECFF 100%);max-width: unset; }
.advantages .grid-4 { display: grid; grid-template-columns: repeat(4, 1fr); align-items: stretch; gap: 16px; max-width: 100%; margin: 0 auto; }
.advantages .adv-card { min-width: 0; }
.adv-card { min-height:240px;position: relative; background: #fff;  border-radius: 4px;  padding: 29px; padding-top: 70px; display: flex; flex-direction: column; box-sizing: border-box; text-align: start; }
.adv-badge { position: absolute; top: 33px; left: 29px; width: 24px; height: 24px; border-radius: 4px; background: #1890FF; color: #fff; display: flex; align-items: center; justify-content: center; font-size: 14px; font-weight: 600; }
.adv-title { font-size: 18px; font-family: PingFang SC; color: #333; margin-bottom: 10px; font-weight: 600; }
.adv-desc { font-size: 14px; line-height: 1.6; color: #333; }
.main-content{
  background: #fff;
}
#scenarios{
  max-width: unset;
  background: #F5F7FA;

  /* max-width: 1182px; */
}
</style>

